/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { confirmImageUploadDataCollectionSchema } from './ConfirmImageUploadDataCollectionSchema'

export const confirmImageUploadDataSchema = z.object({
	id: z.string().uuid(),
	filename: z.string(),
	collection: confirmImageUploadDataCollectionSchema,
	meta: z.array(z.string()).nullable().optional(),
})

export type ConfirmImageUploadDataSchema = z.infer<typeof confirmImageUploadDataSchema>
